const usd = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

const compact = new Intl.NumberFormat("en-US", {
  notation: "compact",
  maximumFractionDigits: 1,
});

const integer = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 });

export const fmtUSD = (v: number | null | undefined) =>
  v == null ? "—" : usd.format(v);

export const fmtUSDCompact = (v: number | null | undefined) =>
  v == null ? "—" : "$" + compact.format(v);

export const fmtInt = (v: number | null | undefined) =>
  v == null ? "—" : integer.format(v);

export function fmtDelta(pct: number | null | undefined): string {
  if (pct == null || !Number.isFinite(pct)) return "—";
  const sign = pct > 0 ? "+" : "";
  return `${sign}${pct.toFixed(1)}%`;
}

export function deltaTone(pct: number | null | undefined): "up" | "down" | "flat" {
  if (pct == null || !Number.isFinite(pct)) return "flat";
  if (pct >= 5) return "up";
  if (pct <= -5) return "down";
  return "flat";
}

export const fmtDate = (iso: string | null | undefined) =>
  !iso ? "—" : new Date(iso + (iso.length === 10 ? "T00:00:00" : "")).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
